export default function About() {
  return (<>
    <section id="about" className="about">
      <div className="container">
        <div className="section-title">
          <h2>About</h2>
          <p style={{"textAlign":"justify"}}>Introducing a versatile professional with a unique blend of skills, specializing in digital marketing, web design, and web development. With a passion for creating captivating online experiences, this individual combines their expertise in these three domains to deliver exceptional results. Leveraging their in-depth knowledge of SEO techniques and best practices, they ensure that every website they design and develop is search engine friendly, driving organic traffic and maximizing online visibility. Their creative prowess in web design brings concepts to life, crafting visually stunning and user-friendly interfaces that leave a lasting impression. With a proven track record of delivering effective digital marketing campaigns, this multi-talented individual offers a comprehensive solution for businesses seeking to enhance their online presence.</p>
        </div>

        <div className="row">
          <div className="col-lg-12 pt-4 pt-lg-0 content" data-aos="fade-left">
            <h4 style={{ "font-style": "italic" }}>
              Innovation is the heartbeat of a digital marketer and the brushstroke of a web designer, blending creativity with strategy to paint a masterpiece of online experiences.
            </h4>
          </div>
        </div>
      </div>
    </section>
  </>);
}